import { useEffect, useState, useRef } from 'react';
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';

import MessageInfoBox, {MessageErreurApi} from '../../Components/Messages.jsx';
import LoadingSpinner from "../../Components/LoadingSpinner";
import ButtonDeBase from '../../Components/ButtonsCustom.jsx';
import OrganismeListe from './OrganismeListe';

import { appelRecupInfoGet, isValidSIRET } from '../../fonctionsDiv.js';
import { apiCheckSiret, apiInformationsQuiforme } from '../../Datas/dataLogin.js';

// inspi Etape1Siret
const Etape4Antennes = ({ formData, setFormData, organismes,
                          setOrganismes, resetForm,
                          onQuiformeSuccess, onQuiformeFail }) => {

const [dataLoaded, setDataLoaded] = useState(true);
const [spinnerLoad, setSpinnerLoad] = useState(false);
const [messageProbleme, setMessageProbleme] = useState();
const [aumoinsUneModif, setAumoinsUneModif] = useState(false);
const [dataApi, setdataApi] = useState();

const handleCloseModalSiretInactif = () => setShowModalSiretInactif(false);
const [showModalSiretInactif, setShowModalSiretInactif] = useState(false);
const handleCloseModalNoNda = () => setShowModalNoNda(false);
const [showModalNoNda, setShowModalNoNda] = useState(false);

//const [showModE4alInfo, setShowModalE4Info] = useState(false);
//const handleCloseModalE4Info = () => setShowModalE4Info(false);
//const [messagePourModal, setMessagePourModal] = useState(false);

const [siretError, setSiretError] = useState('');
const siretInputRef = useRef(null); // pour eviter de manipuler le dom avec getElementById


const handleSubmit = async () => {
    try {
      // vérification format et présence SIRET en base début
      var leSiret = formData.Siret;

      for(let organisme of organismes) {
        if(organisme.Siret == leSiret) {
          setMessageProbleme("Vous venez de renseigner les informations de l'organisme qui a le Siret " + leSiret  + ".<br />Veuillez renseigner un autre Siret s'il y a lieu ou cliquer sur le bouton 'Envoyer ma demande'");
          return false;
        }
      }
      if(!isValidSIRET(leSiret)) {
        setSiretError("Le siret que vous avez saisi ne semble pas valide, veuillez le corriger.");
        siretInputRef.current && siretInputRef.current.focus();
        return false;
      }
      
      setMessageProbleme();
      setDataLoaded(false);

      var dataR = await apiCheckSiret(leSiret)
      if(global.config.modeDebugApp == 1) console.log('retour apiCheckSiret : ', dataR);

      switch (dataR.statusCode) {
          case 401: // retourne 401 si  resultat != 1
                if(global.config.modeDebugApp == 1) console.log('le Siret est effectivement inexistant : ', leSiret);
              break;
          case 400: 
            setDataLoaded(true);
            if(global.config.modeDebugApp == 1) console.log('problème au niveau de votre Siret : ', leSiret);
            setMessageProbleme(`Il y a un problème au niveau de votre Siret, veuillez vérifier votre saisie.`);
            return false;
          case 200: 
            setDataLoaded(true);
            if(global.config.modeDebugApp == 1) console.log('le Siret est existant.. pas d\'envoie de formulaire : ', leSiret);
            setMessageProblemes("Ce Siret" + leSiret + " existe déjà dans notre base de données, vous n'avez donc pas besoin de le déclarer ici.");       
            return false;
          default:
            setDataLoaded(true);
            if(global.config.modeDebugApp == 1) console.log('Le serveur a rencontré une erreur : ', leSiret);
            setMessageProbleme(`Le serveur a rencontré une erreur, veuillez contacter le support "${global.config.admin.mail}".`);
            return false;
      }
      // vérification format et présence SIRET en base fin


      //recherche des informations QuiForme pour préremplissage
      setSpinnerLoad(true);
      var dataR = await apiInformationsQuiforme(leSiret);
      if(global.config.modeDebugApp == 1) console.log('retour apiInformationsQuiforme : ', dataR);
      setSpinnerLoad(false);

      //var dataApiLoc = new Object(dataApi);
      ////var dataApiLoc = {...dataApi  };
      //dataApiLoc["x_SIRET"] = leSiret;

      switch (dataR.statusCode) {
          case 401: 
            // on teste si c'est une chaine string qui est retourné par l'api
            //if(typeof dataR.dataApi === 'string' || dataR.dataApi instanceof String) alert(dataR.dataApi); // un message personnalisé est retourné dans ce cas, ex : "Il y a plus de XXX résultats ({XXXX), veuillez affiner votre recherche"
            //else alert(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
            //var gotoEtape2Fail = false;
            var msgAdapte = 0
            if(typeof dataR.dataApi === 'string' || dataR.dataApi instanceof String) {
              if(dataR.dataApi.includes("Votre Siret est inactif d'après Quiforme")) { msgAdapte = 1; setShowModalSiretInactif(true)}
              else if(dataR.dataApi.includes("Votre organisme ne possede pas de numéro d'activité d'après Quiforme")) { msgAdapte = 1; setShowModalNoNda(true)}
              else if(dataR.dataApi.includes("Votre Siret n'a pas été trouvé dans Quiforme")) { 
                msgAdapte = 1; 
                //alert(dataR.dataApi);
                //gotoEtape2Fail = true;
                onQuiformeFail();
              }
            }

            if(msgAdapte == 0) alert(global.config.msgPrTechnique.msgDefaut); // Problème technique par défaut
            //if(gotoEtape2Fail) onQuiformeFail();
          break;

          case 200: 
              /*
                if(dataR.dataApi.siret_actif == null) 
                  alert("Le siret " + leSiret + " n'a pas été trouvé dans QuiForme, veuillez le corriger si vous avez commis une erreur.\r\nDans le cas contraire, vous pouvez continuer votre saisie.")
              */         
              
              var numDe = ""
              var dateDerniereDeclaration = ""
              if(dataR.dataApi.nda.length > 0) {
                  numDe = dataR.dataApi.nda[0].nda;

                  if(dataR.dataApi.nda[0].date_derniere_declaration !== null) {
                  const [year, month, day] = dataR.dataApi.nda[0].date_derniere_declaration.split('-');
                  dateDerniereDeclaration = `${day}/${month}/${year}`;// Recompose la date au format dd/mm/yyyy 
                  }
              }

              var date_creation = ""
              if (dataR.dataApi.etablissement.date_creation !== "undefined") {
                  const [year, month, day] = dataR.dataApi.etablissement.date_creation.split('-');
                  date_creation = `${day}/${month}/${year}`;// Recompose la date au format dd/mm/yyyy 
              }

              // si dep de paca 
              const pacaCodes = ["04", "05", "06", "13", "83", "84"];
              var estEnPaca = 1;
              if(dataR.dataApi.adresse_ban.length !== "undefined"){
                //const firstTwo = formData.NumDe ? formData.NumDe.substring(0, 2) : ""; ce que proposait Lydia sur num d'activité ne marche pas  
                const firstTwo = dataR.dataApi.adresse_ban[0].codepostal ? dataR.dataApi.adresse_ban[0].codepostal.substring(0, 2) : "";

                if (firstTwo != "" && !pacaCodes.includes(firstTwo)) estEnPaca = 0;

                if(estEnPaca == 0) {
                  setMessageProbleme("L'organisme ayant le Siret " + leSiret + " n’est pas en Provence-Alpes-Côte d'Azur d'après QuiForme (departement : " + firstTwo + ").<br />Veuillez en saisir un autre ou indiquer que vous avez terminé votre demande.");
                  return false;
                }
              }


              setFormData({
                  ...formData,
                  QuiformeEstlaSource: true,

                  Siret: dataR.dataApi.siret_actif !== "undefined" ? dataR.dataApi.siret_actif : "",                  

                  RaisonSociale: dataR.dataApi.unite_legale.raison_sociale !== "undefined" ? dataR.dataApi.unite_legale.raison_sociale : "", 
                  Cat_juridique: dataR.dataApi.unite_legale.cat_juridique !== "undefined" ? dataR.dataApi.unite_legale.cat_juridique : "", 
                  Libelle_cat_juridique: dataR.dataApi.unite_legale.libelle_cat_juridique !== "undefined" ? dataR.dataApi.unite_legale.libelle_cat_juridique : "", 
                  Sigle: dataR.dataApi.unite_legale.sigle !== "undefined" ? dataR.dataApi.unite_legale.sigle : "", 

                  Denomination: dataR.dataApi.etablissement.denomination !== "undefined" ? dataR.dataApi.etablissement.denomination : "",
                  Enseigne: dataR.dataApi.etablissement.enseigne !== "undefined" ? dataR.dataApi.etablissement.enseigne : "",
                  Code_ape: dataR.dataApi.etablissement.code_ape !== "undefined" ? dataR.dataApi.etablissement.code_ape : "",
                  Date_creation: date_creation,

                  Uai: dataR.dataApi.etablissement.uai !== "undefined" ? dataR.dataApi.etablissement.uai : "",
                  NumDe: numDe,
                  DateDerniereDeclaration: dateDerniereDeclaration,

                  Adresse1: dataR.dataApi.adresse_ban.length !== "undefined" ? dataR.dataApi.adresse_ban[0].nom : "",
                  Adresse2: "",
                  VilleId: 0,
                  Codepostal: dataR.dataApi.adresse_ban.length !== "undefined" ? dataR.dataApi.adresse_ban[0].codepostal : "",
                  Commune: dataR.dataApi.adresse_ban.length !== "undefined" ? dataR.dataApi.adresse_ban[0].commune : "",

                  QualiopiActionFormation: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_action_formation : null,
                  QualiopiBilanCompetence: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_bilan_competence : null,
                  QualiopiVae: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_vae : null,
                  QualiopiApprentissage: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_apprentissage : null,

                  EstEnPaca: estEnPaca,
                  //EstCfa: dataR.dataApi.nda.length !== "undefined" ? dataR.dataApi.nda[0].qualiopi_apprentissage : "", ne veut pas dire que c'est un cfa
                  });
              //console.log('formData set : ', formData);
              onQuiformeSuccess();
            break;

          default:
            // silencieux si il y a le moindre problème....
            //if(global.config.modeDebugApp == 1) console.log('Le serveur a rencontré une erreur : ', leSiret);
            //setMessageProbleme(`Le serveur a rencontré une erreur, veuillez contacter le support "${global.config.admin.mail}".`);
            alert("Le service QuiForme qui permet de pré remplir le formulaire en fonction de votre Siret semble poser problème, veuillez s'il vous plait renseigner les champs manuellement.")       
            break;
      }
        
       //setdataApi(dataApiLoc)      
    } catch (err) {
      console.error(err);
      alert("Erreur réseau 4.");
    }
  };

    useEffect(() => {  
        setMessageProbleme(null);
    }, []);

  return (
    <>
      <div className="bloc-centre">
          {global.config.modeDebugAppDisplayInfosSupp == 1 && <div className='debug'>Etape4Antennes</div>}
          <LoadingSpinner dataLoaded={!spinnerLoad} message="Obtention des données propres à votre SIRET aurpès de QuiForme..."  className="spinner-container3"/>
          <MessageErreurApi message={messageProbleme} />
          
          <div className="texte-gros2" style={{ paddingBottom: 10 }}>
          {organismes.length  == 1 ? 
            <><p className="texte-gros">Vous venez de renseigner l'organisme ci-dessous.</p>Vous devez maintenant déclarer au moins une antenne qui se trouve en Provence Alpes Cote d'Azur</>
            : 
            <><p className="texte-gros">Vous venez de renseigner les organismes ci-dessous.</p>Vous pouvez déclarer une autre antenne se trouvant en Provence Alpes Cote d'Azur ou cliquer sur le bouton 'Soumettre ma demande'</>
            }
          </div>
          
          <input
          id="x_SIRET"
          type="text"
          value={formData.Siret}
          onChange={(e) => {
              setFormData({ ...formData, Siret: e.target.value });
              setAumoinsUneModif(true);
          }}
          placeholder="renseigner ici le siret d'une antenne"
          className="form-control form-input-lg-short"
          style={{ width: "200px", marginRight: 10, display: "inline"}}
          />

          {siretError && (
            <div className="text-danger pb-4" style={{ marginTop: 5 }}>{siretError}</div>
          )}
          {formData.Siret.length == 14 &&
          <ButtonDeBase typeSubmit={false} onClick={handleSubmit} lib="Déclarer cette antenne" className2="myside2" />
          }
      </div>

      {organismes.length > 0 && (
        <OrganismeListe
          organismes={organismes}
          setOrganismes = {setOrganismes}
          resetForm = {resetForm}
        />
      )}

{/*
        {showModE4alInfo &&
        <Modal size="lg" show={showModE4alInfo} onHide={handleCloseModalE4Info} backdrop="static" keyboard={false} centered aria-labelledby="m1">
            <Modal.Header closeButton>
            <Modal.Title id="m1">
                Attention
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {messagePourModal}
            </Modal.Body>
        </Modal>
        }
*/}
        {showModalSiretInactif &&
        <Modal size="lg" show={showModalSiretInactif} onHide={handleCloseModalSiretInactif} backdrop="static" keyboard={false} centered aria-labelledby="m2">
            <Modal.Header closeButton>
            <Modal.Title id="m2">
                 Siret inactif
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            Votre Siret {`${formData.Siret}`} est inactif d'après QuiForme<OverlayTrigger placement="right" overlay={renderTooltip2} ><button className="simply" type='button'><span className="fas fa-circle-question"></span></button>
            </OverlayTrigger> , merci de sélectionner l'un des Siret proposés par <a href={`https://www.intercariforef.org/rco_search/quiforme/etablissement/?rech=${formData.Siret.substring(0, 9)}`} target="_blank">Quiforme</a>.
            <br />En cas de problème, vous pouvez contacter le CARIF via ce courriel : eo-bo@cariforef.fr.
            </Modal.Body>
        </Modal>
        }
        {showModalNoNda &&
        <Modal size="lg" show={showModalNoNda} onHide={handleCloseModalNoNda} backdrop="static" keyboard={false} centered aria-labelledby="m3">
            <Modal.Header closeButton>
            <Modal.Title id="m3">
                 Organisme sans numéro d'activité
            </Modal.Title>
            </Modal.Header>
            <Modal.Body>
            Votre organisme ne possede pas de numéro d'activité d'après QuiForme<OverlayTrigger placement="right" overlay={renderTooltip2} ><button className="simply" type='button'><span className="fas fa-circle-question"></span></button>
            </OverlayTrigger>
            <br />En cas de problème, vous pouvez contacter le CARIF via ce courriel : eo-bo@cariforef.fr.
            </Modal.Body>
        </Modal>
        }
      </>
  );
};

export default Etape4Antennes;